import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import ImportarClientesExcel from '../../components/importarClientesExcel/ImportarClientesExcel'
import {submitImportarClientesExcel, cerrarModalImportarClientesExcel, subirArchivosImportarClientesExcel, abrirModalImportarClientesExcel, descargarPlantillaExcelClientesExcel} from '../../actions/importarClientesExcel/importarClientesExcel'

export function mapStateToProps (state) {
  return {
    ...state.importarClientesExcel,
    combos: state.combos
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      submitImportarClientesExcel,
      cerrarModalImportarClientesExcel,
      subirArchivosImportarClientesExcel,
      abrirModalImportarClientesExcel,
      descargarPlantillaExcelClientesExcel
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ImportarClientesExcel))